import type { LocaleLoaders } from '@wegic/i18n-core';
import { I18nLanguage } from '@wegic/i18n-core/const';

/**
 * 支持的语言枚举（从 @wegic/i18n-core 导入）
 */
export { I18nLanguage };

export const SUPPORTED_I18N_LANGUAGES: ReadonlySet<string> = new Set(Object.values(I18nLanguage));

/**
 * 存储语言偏好的 Cookie key
 */
export const LANGUAGE_COOKIE_KEY = 'NEXT_LOCALE';

/**
 * 默认语言
 */
export const defaultLanguage = I18nLanguage.en;

/**
 * Cookie 过期时间（1年，单位：秒）
 */
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

/**
 * Builder 应用的 i18n 命名空间
 */
export const BUILDER_I18N_NAMESPACE = 'builder';

/**
 * Builder 应用的 i18n 加载器配置
 */
export const builderI18nLoaders: LocaleLoaders = {
  [I18nLanguage.en]: () => import('./locales/en.json'),
  [I18nLanguage.ja]: () => import('./locales/ja.json'),
  [I18nLanguage.de]: () => import('./locales/de.json'),
  [I18nLanguage.fr]: () => import('./locales/fr.json'),
  [I18nLanguage.es]: () => import('./locales/es.json'),
  [I18nLanguage.it]: () => import('./locales/it.json'),
  [I18nLanguage.nl]: () => import('./locales/nl.json'),
  [I18nLanguage.tr]: () => import('./locales/tr.json'),
  [I18nLanguage.zhCN]: () => import('./locales/zh-cn.json'),
  [I18nLanguage.zhHK]: () => import('./locales/zh-hk.json'),
  [I18nLanguage.ptPT]: () => import('./locales/pt-pt.json'),
  [I18nLanguage.ptBR]: () => import('./locales/pt-br.json'),
  [I18nLanguage.vi]: () => import('./locales/vi.json'),
};
